module.exports = __webpack_public_path__ + "img/DK.be60e04c.svg";